var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-1 -1 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "m12.52 10.192l-.581.582a31.121 31.121 0 0 1-2.827-2.83l.58-.58a3 3 0 0 0 0-4.243L8.278 1.707a3 3 0 0 0-4.242 0L1.23 4.513A1 1 0 0 0 1 5.57c2.374 6.36 6.818 10.834 13.308 13.312a1 1 0 0 0 1.064-.227l2.806-2.806a3 3 0 0 0 0-4.242l-1.415-1.415a3 3 0 0 0-4.242 0m4.244 2.829a1 1 0 0 1 0 1.414l-2.342 2.341c-5.424-2.23-9.173-6-11.317-11.31L5.45 3.12a1 1 0 0 1 1.414 0l1.414 1.415a1 1 0 0 1 0 1.414L7.044 7.184a1 1 0 0 0-.063 1.345a33.163 33.163 0 0 0 4.373 4.376a1 1 0 0 0 1.345-.063l1.236-1.235a1 1 0 0 1 1.414 0z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.23b2f001494601d817ab087b345e8e6e.svg";
export { ForwardRef as ReactComponent };